module.exports = __webpack_public_path__ + "img/iconfont.48279a21.svg";